//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as systemConfigApi from '@/api/systemConfig.js';
export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      title: 'Vue Element Admin',
      logo: '',
      logoSmall: ''
    };
  },
  mounted: function mounted() {
    // this.getLogo()
    // this.getSquareLogo()
  },
  methods: {
    // getLogo() {
    //   systemConfigApi.configGetUniq({key: "site_logo_lefttop"}).then(data => {
    //     this.logo = data
    //   })
    // },
    // getSquareLogo() {
    //   systemConfigApi.configGetUniq({key: "site_logo_square"}).then(data => {
    //     this.logoSmall = data
    //   })
    // }
  }
};